import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { fromEvent, Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";
import * as XLSX from "xlsx";
import { ModalAddBeneficiaireComponent } from "src/app/parametres/param-production/beneficiaire/modal-add-beneficiaire/modal-add-beneficiaire.component";

@Component({
  selector: "app-upload-excel-beneficiaire",
  templateUrl: "./upload-excel-beneficiaire.component.html",
  styleUrls: ["./upload-excel-beneficiaire.component.scss"],
})
export class UploadExcelBeneficiaireComponent implements OnInit, OnDestroy {
  @Output() onLoadExcelBenef = new EventEmitter<any>();
  @Output() onReloadList = new EventEmitter<any>();
  @Input() garant_id: any;
  @Input() souscripteur_id: any;
  @Input() police_id: any;
  @Input() sessionMode: boolean=false;
  @Input() college_id: any;
  @Output() afterSavingMass = new EventEmitter<any>();
  @Output() afterSavingSingle = new EventEmitter<any>();

  @ViewChild("fileInput") fileInput: ElementRef;
  
  user: any;
  busyGet: Subscription | null = null;
  modalRef: BsModalRef;
  fileChangeSubscription: Subscription;
  itemsToSaveBenef: any[] = [];
  isProcessingFile: boolean = false;

  constructor(
    private restClient: RestClientService,
    private authService: AuthService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    this.user = this.authService.getCurrentUser();
  }

  ngOnInit(): void {
    // Initialization logic here
    console.log('college_id: ',this.college_id)
    console.log('police_id: ',this.police_id)
    console.log('souscripteur_id: ',this.souscripteur_id)
    console.log('garant_id: ',this.garant_id)
    console.log("sessionMode in bénéficiaire: ",this.sessionMode)

  }

  ngAfterViewInit() {
    // Set up file input change listener
    if (this.fileInput?.nativeElement) {
      this.fileChangeSubscription = fromEvent(this.fileInput.nativeElement, "change").subscribe(
        (event: any) => {
          this.onFileChange(event);
        }
      );
    }


  }

  ngOnDestroy() {
    // Clean up subscriptions
    if (this.busyGet) {
      this.busyGet.unsubscribe();
      this.busyGet = null;
    }
    if (this.fileChangeSubscription) {
      this.fileChangeSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes: ", changes);
  }

  onFileChange(event: any) {
    console.log("File change event triggered");
    console.log("event.target.files: ", event.target.files);
    
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected");
      return;
    }

    // Validate file type
    if (!this.isValidExcelFile(file)) {
      this.showError("Veuillez sélectionner un fichier Excel valide (.xlsx)");
      this.resetFileInput();
      return;
    }

    console.log("File details:", {
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: new Date(file.lastModified)
    });

    this.isProcessingFile = true;
    this.processExcelFile(file);
  }

  private isValidExcelFile(file: File): boolean {
    const validExtensions = ['.xlsx', '.xls'];
    const validMimeTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];
    
    const fileName = file.name.toLowerCase();
    const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
    const hasValidMimeType = validMimeTypes.includes(file.type);
    
    return hasValidExtension || hasValidMimeType;
  }

  private processExcelFile(file: File) {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const data = e.target.result;
        const workBook = XLSX.read(data, { type: "binary" });
        
        console.log("Available sheet names:", workBook.SheetNames);
        
        if (workBook.SheetNames.length === 0) {
          this.showError("Le fichier Excel ne contient aucune feuille");
          this.resetFileInput();
          return;
        }

        const jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet, { 
            header: 1,
            defval: '',
            blankrows: false 
          });
          return initial;
        }, {} as any);
        
        console.log("Parsed JSON data:", jsonData);

        // Try to find beneficiaires sheet or use first sheet
        let beneficiairesData = this.findBeneficiairesData(jsonData);
        
        if (!beneficiairesData || beneficiairesData.length === 0) {
          this.showError("Aucune donnée de bénéficiaires trouvée dans le fichier");
          this.resetFileInput();
          return;
        }

        // Convert array of arrays to array of objects
        const processedData = this.convertToObjectArray(beneficiairesData);
        
        this.itemsToSaveBenef = processedData.map((item, index) => ({
          ...item,
          id_ligne: index,
          date_naissance: this.excelDateToJSDate(item["date_naissance"]),
          date_entree: this.excelDateToJSDate(item["date_entree"]),
        }));

        this.orderByFamille();

        console.log("Processed beneficiaires data: ", this.itemsToSaveBenef);
        
        if (this.itemsToSaveBenef.length > 0) {
          this.onLoadExcelBenef.emit(this.itemsToSaveBenef);
          // this.showSuccess(`${this.itemsToSaveBenef.length} bénéficiaires importés avec succès`);
        } else {
          // this.showError("Aucun bénéficiaire valide trouvé dans le fichier");
        }
        
      } catch (error) {
        console.error("Error processing Excel file:", error);
        this.showError("Erreur lors du traitement du fichier Excel");
      } finally {
        this.isProcessingFile = false;
        this.resetFileInput();
      }
    };

    reader.onerror = (error) => {
      console.error("FileReader error:", error);
      this.showError("Erreur lors de la lecture du fichier");
      this.isProcessingFile = false;
      this.resetFileInput();
    };

    reader.readAsBinaryString(file);
  }

  private findBeneficiairesData(jsonData: any): any[] {
    // First try to find sheet named 'beneficiaires'
    if (jsonData['beneficiaires']) {
      return jsonData['beneficiaires'];
    }
    
    // Try case-insensitive search
    const sheetNames = Object.keys(jsonData);
    const beneficiairesSheet = sheetNames.find(name => 
      name.toLowerCase().includes('beneficiaire') || 
      name.toLowerCase().includes('bénéficiaire')
    );
    
    if (beneficiairesSheet) {
      return jsonData[beneficiairesSheet];
    }
    
    // If no specific sheet found, use the first sheet
    const firstSheetName = sheetNames[0];
    console.log(`No 'beneficiaires' sheet found, using first sheet: ${firstSheetName}`);
    return jsonData[firstSheetName];
  }

  private convertToObjectArray(data: any[][]): any[] {
    if (data.length < 2) {
      return [];
    }
    
    const headers = data[0];
    const rows = data.slice(1);
    
    return rows.map(row => {
      const obj: any = {};
      headers.forEach((header, index) => {
        obj[header] = row[index] || '';
      });
      return obj;
    }).filter(obj => Object.values(obj).some(val => val !== ''));
  }

  private resetFileInput() {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = "";
    }
  }

  private showError(message: string) {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: message,
      confirmButtonText: 'OK'
    });
  }

  private showSuccess(message: string) {
    Swal.fire({
      icon: 'success',
      title: 'Succès',
      text: message,
      confirmButtonText: 'OK',
      timer: 3000
    });
  }

  orderByFamille() {
    if (this.itemsToSaveBenef && this.itemsToSaveBenef.length > 0) {
      this.itemsToSaveBenef = _.orderBy(
        this.itemsToSaveBenef,
        ["regroupement_famille"],
        ["asc"]
      );
    }
  }

  excelDateToJSDate(excelDate: number | string): Date | null {
    try {
      // Handle empty or null values
      if (!excelDate && excelDate !== 0) {
        return null;
      }

      // If the input is already a valid date string, try to parse it
      if (typeof excelDate === "string") {
        // Check if it's already a valid date format
        const parsedDate = new Date(excelDate);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
        
        // Try to convert string to number for Excel serial date
        const numericDate = parseFloat(excelDate);
        if (isNaN(numericDate)) {
          console.warn("Unable to parse date:", excelDate);
          return null;
        }
        excelDate = numericDate;
      }

      // Handle Excel serial date numbers
      if (typeof excelDate === "number") {
        // Excel's date system starts on January 1, 1900
        // But Excel incorrectly considers 1900 as a leap year
        const millisecondsPerDay = 24 * 60 * 60 * 1000;
        const excelEpoch = new Date(1900, 0, 1); // January 1, 1900
        
        // Calculate the JavaScript date
        let jsDate: Date;
        if (excelDate < 60) {
          // Dates before March 1, 1900 (Excel serial 60)
          jsDate = new Date(excelEpoch.getTime() + (excelDate - 1) * millisecondsPerDay);
        } else {
          // Dates on or after March 1, 1900 - subtract 1 day to account for Excel's leap year bug
          jsDate = new Date(excelEpoch.getTime() + (excelDate - 2) * millisecondsPerDay);
        }

        // Validate the resulting date
        if (isNaN(jsDate.getTime())) {
          console.warn("Invalid date result for:", excelDate);
          return null;
        }

        return jsDate;
      }

      console.warn("Unsupported date format:", excelDate);
      return null;
      
    } catch (error) {
      console.error("Error converting Excel date:", error, "Input:", excelDate);
      return null;
    }
  }

  triggerFileInput() {
    if (this.isProcessingFile) {
      this.showError("Un fichier est en cours de traitement, veuillez attendre");
      return;
    }
    
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.click();
    }
  }

  downloadExcelTemplate() {
    if (this.busyGet) {
      return; // Prevent multiple simultaneous requests
    }

    const request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      data: {},
    };

    this.busyGet = this.restClient
      .post("excelTemplate/getBeneficiaireModel", request)
      .subscribe({
        next: (res) => {
          if (res && res["item"] && res["item"].file_url) {
            window.open(res["item"].file_url, '_blank');
          } else {
            this.showError("Modèle de fichier non disponible");
          }
        },
        error: (err) => {
          console.error("Error downloading template:", err);
          this.showError("Erreur lors du téléchargement du modèle");
        },
        complete: () => {
          this.busyGet = null;
        }
      });
  }

  openAddItemModal(data?: any) {
    const modal = ModalAddBeneficiaireComponent;
    
    this.modalRef = this.modalService.show(modal, {
      id: 59,
      class: "modal-width-90",
      ignoreBackdropClick: true,
    });
    if(this.sessionMode && data){
      data.sessionMode=true
    }
    if (data) {
       if(this.sessionMode){
      data.sessionMode=true
    }
      this.modalRef.content.currentData = data;

    }
    else{
         if(this.sessionMode){
     this.modalRef.content.currentData = {sessionMode:true};
    }
      

    }
    
    // Set additional context data
    this.modalRef.content.garant_id = this.garant_id;
    this.modalRef.content.souscripteur_id = this.souscripteur_id;
    this.modalRef.content.police_id = this.police_id;
    this.modalRef.content.college_id = this.college_id;
    
    this.modalRef.onHide.subscribe(() => {
      this.onReloadList.emit("reload");
    });
  }
}